import { onDocumentEvent } from '@app/utils/jquery-alternatives'

const accountsSelectors = "[data-behaviour~='ledger-copier-account-selector']"
const reconciliationsSelectors =
  "[data-behaviour~='ledger-copier-reconciliation-selector']"

const uncheckSelectAll = () => {
  document.dispatchEvent(new CustomEvent('ledger-copier:deselect-all'))
}

const resetTemplateSelectors = () => {
  document.querySelectorAll(accountsSelectors).forEach((item) => {
    const target = item.dataset.target
    const accountsContainer = document.querySelector(`.accounts-${target}`)
    if (!accountsContainer) return

    const checkboxes = accountsContainer.querySelectorAll(
      'input[type="checkbox"]'
    )
    const checkedBoxes = accountsContainer.querySelectorAll(
      'input[type="checkbox"]:checked'
    )
    const allChecked =
      checkboxes.length !== 0 && checkboxes.length === checkedBoxes.length
    item.checked = allChecked
  })

  document.querySelectorAll(reconciliationsSelectors).forEach((item) => {
    const input = item.querySelector('input[data-workflow-id]')
    if (!input) return

    const workflowId = input.dataset.workflowId
    const reconTextsList = document.querySelector(
      `[data-behaviour~='ledger-copier-workflow-list'][data-workflow-id~='${workflowId}']`
    )
    if (!reconTextsList) return

    const checkboxes = reconTextsList.querySelectorAll('input[type="checkbox"]')
    const checkedBoxes = reconTextsList.querySelectorAll(
      'input[type="checkbox"]:checked'
    )
    const allChecked =
      checkboxes.length !== 0 && checkboxes.length === checkedBoxes.length
    item.querySelector('input[type="checkbox"]').checked = allChecked
  })
}

// We may have few elements with the same value and name in DOM, we
// want to be able to check/uncheck them all together.
const setCheckedOnSameElements = (el, isChecked) => {
  document
    .querySelectorAll(
      `[data-behaviour~='ledger-copier-reconciliation-texts-list']`
    )
    .forEach((list) => {
      list
        .querySelectorAll(
          `input[name='${el.getAttribute('name')}'][value='${el.getAttribute(
            'value'
          )}']`
        )
        .forEach((input) => {
          input.checked = isChecked
        })
    })
}

const updateConfirm = () => {
  const existingData = []
  document
    .querySelectorAll('[data-existing-data]:checked')
    .forEach((input) => existingData.push(input.dataset.existingData))
  const submit = document.querySelector("form.ledger-copy [type='submit']")
  submit.onclick = (e) => {
    if (existingData.length === 0 || submit.dataset.confirmed === '1') {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    let existingDataWarning = existingData.slice(0, 3).join(', ')
    if (existingData.length > 2) {
      existingDataWarning += I18n.t('shared.used_x_times_more', {
        count: existingData.length - 3,
      })
    }
    window.sfConfirm({
      question: I18n.t(
        'ledger_import.prepare_period.js.override_data_question',
        { period: submit.dataset.period }
      ),
      message: I18n.t('ledger_import.prepare_period.js.override_data_message', {
        existing: existingDataWarning,
      }),
      confirmLabel: I18n.t(
        'ledger_import.prepare_period.js.override_data_confirm',
        { period: submit.dataset.period }
      ),
      onConfirm: () => {
        submit.dataset.confirmed = '1'
        submit.click()
      },
    })
  }
}

const updateCount = (checkboxWrapper) => {
  const header = document.getElementById(checkboxWrapper.dataset.header)
  const card = header.closest('.card')
  const checkboxes = card.querySelectorAll('.card-body input[type=checkbox]')
  const checkedCount = card.querySelectorAll(
    '.card-body input[type=checkbox]:checked'
  ).length
  updateConfirm()
  updateCounterAttributes(
    header.querySelector('div.counter'),
    checkedCount,
    checkboxes.length
  )
}

const updateCounterAttributes = (counter, checked, total) => {
  counter.classList.remove('sf-label-primary', 'sf-label-active')
  if (checked !== 0) {
    counter.classList.add('sf-label-primary')
    if (checked === total) {
      counter.classList.add('sf-label-active')
    }
  }
  counter.textContent = `${checked}/${total}`
}

export default () => {
  const removePeriodSelector = onDocumentEvent(
    document,
    'change',
    '[data-behaviour="ledger-copier-period-selector"] select',
    async () => {
      const wrapper = document.querySelector(
        '[data-behaviour="ledger-copier-period-selector"]'
      )

      const form = wrapper.querySelector('form')
      const formData = new FormData(form)
      const params = new URLSearchParams({
        authenticity_token: formData.get('authenticity_token'),
        'ledger_copier[source_id]': formData.get('ledger_copier[source_id]'),
      })
      const data = params.toString()
      const firmId = document.getElementById('current_firm_id').value
      const ledgerId = wrapper.dataset.ledger_id
      const companyId = document.getElementById('current_company_id').value

      const url = Silverfin.Routes.new_ledger_ledger_copier_path({
        firm_id: firmId,
        company_id: companyId,
        ledger_id: ledgerId,
      })

      Silverfin.Spinner.start()

      try {
        const response = await fetch(`${url}?${data}`, {
          headers: {
            Accept: 'text/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const text = await response.text()
        const script = document.createElement('script')
        script.textContent = text
        document.head.appendChild(script)
        document.head.removeChild(script)

        Silverfin.Spinner.success()
        const submit = document.querySelector(
          "form.ledger-copy [type='submit']"
        )
        submit.removeAttribute('disabled')
        resetTemplateSelectors()
        document.dispatchEvent(
          new CustomEvent('ledger-copier:templates-loaded')
        )
      } catch {
        // Network or HTTP error - spinner remains in non-success state
      }
    }
  )

  const removeAccountSelector = onDocumentEvent(
    document,
    'change',
    accountsSelectors,
    (e) => {
      const target = e.target.dataset.target
      const checked = e.target.checked

      document
        .querySelectorAll(`.accounts-${target} input[type=checkbox]`)
        .forEach((cb) => {
          cb.checked = checked
        })
      updateCount(e.target)

      if (!checked) {
        uncheckSelectAll()
      }
    }
  )

  const removePeriodProperties = onDocumentEvent(
    document,
    'change',
    '#ledger_copier_general_period_properties',
    () => {
      updateConfirm()
    }
  )

  const removeReconciliationSelector = onDocumentEvent(
    document,
    'click',
    reconciliationsSelectors,
    (e) => {
      // "Select all" for reconciliation texts needs different
      // implementation than accounts because it has to multi-select the
      // same items between different workflows. That's why we prevent
      // event propagation, so we can handle inputs on our own.
      //
      // Setting data-behaviour on wrapper is a hack for native HTML
      // behaviour. The problem is that all labels and inputs share one
      // ID, so if we click any input/label it will always target the
      // first element. That's why we listen on wrapper click and look for
      // input in this wrapper.
      e.preventDefault()

      const wrapper = e.target.closest(reconciliationsSelectors)
      const input = wrapper.querySelector('input[data-workflow-id]')
      const workflowId = input.dataset.workflowId
      const checked = input.checked

      const reconTextsList = document.querySelector(
        `[data-behaviour~='ledger-copier-workflow-list'][data-workflow-id~='${workflowId}']`
      )
      if (!reconTextsList) return

      reconTextsList.querySelectorAll('input[type=checkbox]').forEach((el) => {
        setCheckedOnSameElements(el, !checked)
      })

      input.checked = !checked
      updateCount(wrapper)

      if (checked) {
        uncheckSelectAll()
      }
    }
  )

  const removeReconciliationSingle = onDocumentEvent(
    document,
    'click',
    "[data-behaviour~='ledger-copier-reconciliation-single']",
    (e) => {
      // We prevent event propagation in this case because we handle
      // checking items between all workflows, not just the clicked one.
      e.preventDefault()

      const wrapper = e.target.closest(
        "[data-behaviour~='ledger-copier-reconciliation-single']"
      )
      const input = wrapper.querySelector('input')
      const checked = input.checked

      setCheckedOnSameElements(input, !checked)
      updateCount(wrapper)

      if (checked) {
        uncheckSelectAll()
      }
    }
  )

  const removeAccountsList = onDocumentEvent(
    document,
    'change',
    "[data-behaviour~='ledger-copier-accounts-list'] .card-body input[type=checkbox]",
    (e) => {
      updateCount(e.target)

      if (!e.target.checked) {
        uncheckSelectAll()
      }
    }
  )

  return () => {
    removePeriodSelector()
    removeAccountSelector()
    removePeriodProperties()
    removeReconciliationSelector()
    removeReconciliationSingle()
    removeAccountsList()
  }
}
